module.exports = __webpack_public_path__ + "fonts/Roboto-BlackItalic.eb33cc12.ttf";